export default __webpack_public_path__ + "static/media/shell.7e10fd26.png";